module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="gmf-lidarprofile-container" class="panel" ng-show="$ctrl.active">\n  <div class="lidarprofile">\n    <div class="lidar-error"></div>\n    <canvas class="lidar-canvas"></canvas>\n    <svg class="lidar-svg" style="fill: #ffff00;position:absolute;z-index:1;"></svg>\n  </div>\n  <div class="lidar-legend">\n    <div class="width-info"></div>\n    <div class="lod-info"></div>\n    <div class="lidar-info"></div>\n  </div>\n  <div\n    class="close"\n    ng-click="$ctrl.line = null">&times;\n  </div>\n</div>\n';

}
return __p
}